import { AlertTriangle, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";

const fmt = (n) => Math.round(Number(n || 0)).toLocaleString("en-IN"); // production units are whole pieces
const daysLate = (iso) => Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));

// Red alert for OSP gate passes still at the vendor past their expected return date.
export default function VendorOverdueBanner({ gatePasses = [], onReview }) {
  const late = gatePasses
    .filter((g) => g.status === "With Vendor" && g.overdue)
    .sort((a, b) => new Date(a.expected_return) - new Date(b.expected_return));
  if (!late.length) return null;
  const units = late.reduce((s, g) => s + Number(g.pending_qty ?? g.quantity ?? 0), 0);
  const vendors = new Set(late.map((g) => g.vendor_name));
  return (
    <div className="rounded-xl border border-red-300 bg-red-50 px-4 py-3 flex items-center gap-3" data-testid="vendor-overdue-banner">
      <AlertTriangle className="h-5 w-5 text-red-600 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-red-900">
          {late.length} gate pass{late.length !== 1 ? "es" : ""} overdue at {vendors.size} vendor{vendors.size !== 1 ? "s" : ""} — {fmt(units)} pcs past the expected return date
        </p>
        <p className="text-xs text-red-700 truncate" data-testid="vendor-overdue-detail">
          {late.slice(0, 3).map((g) => `${g.gp_number} · ${g.vendor_name} · ${g.order_code} · ${daysLate(g.expected_return)}d late`).join("  |  ")}{late.length > 3 ? `  |  +${late.length - 3} more` : ""}
        </p>
      </div>
      {onReview && (
        <Button size="sm" className="h-8 text-xs bg-red-600 hover:bg-red-700 shrink-0" onClick={onReview} data-testid="vendor-overdue-review">
          <Truck className="h-3.5 w-3.5 mr-1" /> Chase Vendors
        </Button>
      )}
    </div>
  );
}
